<template>
  <b-card>
    <div v-if="loading" class="text-center">
      <b-spinner class="mt-2" variant="secondary" large />
    </div>
    <template v-else>
      <h5>Resumo de valores OKR</h5>
      <b-row>
        <b-col cols="12" md="3" class="mb-2 mb-md-0">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <div class="circle dollar-avatar">
                <feather-icon icon="DollarSignIcon" class="img_avatar" />
              </div>
            </b-media-aside>
            <b-media-body class="my-auto">  
              <b-card-text class="font-small-3 mb-0">
                Valor atual (R$)
              </b-card-text>
              <h5 class="font-weight-bolder mb-0">
                {{ realizedTotal | toCurrency }}
              </h5>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col cols="12" md="3" class="mb-2 mb-md-0">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <div class="circle flag-avatar">
                <feather-icon icon="FlagIcon" class="img_avatar" />
              </div>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-card-text class="font-small-3 mb-0">
                Valor atual OkR
              </b-card-text>
              <h5 class="font-weight-bolder mb-0">
                {{ plannedTotal | toCurrency }}
              </h5>
            </b-media-body>
          </b-media>
        </b-col>
        <b-col cols="12" md="3" class="mb-2 mb-md-0">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <div class="circle user-avatar">
                <feather-icon icon="UserIcon" class="img_avatar" />
              </div>
            </b-media-aside>
            <b-media-body class="my-auto">
              <b-card-text class="font-small-3 mb-0">
                Total de PNs no time
              </b-card-text>
              <h5 class="font-weight-bolder mb-0">
                {{ consultantsCount }}
              </h5>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </template>
  </b-card>
</template>
<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BCard,
  BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import * as types from '../store/types'
import VueSlider from "vue-slider-component";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BSpinner,
    vSelect,
    VueSlider
  },
  directives: {
    Ripple,
  },
  setup() {
    return { toast: useToast() }
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    consultantsCount: {
      type: Number,
      default: 0
    },
  },
  computed: {
    ...mapGetters({
      totalizer: types.OKR_OVERVIEW_TOTALIZER,
    }),
    realizedTotal() {
      return this.totalizer? this.totalizer.realized_okr : 0
    },
    plannedTotal() {
      return this.totalizer? this.totalizer.planned_okr : 0
    }
  },
}
</script>
<style lang="scss">
.circle {
  width: 100%;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 100%;
}

// Ícone Dollar - Verde
.circle.dollar-avatar {
  background-color: #22c55e; // Verde claro
  border-color: #16a34a;
}
.circle.dollar-avatar .img_avatar {
  width: 20px;
  height: 20px;
  color: #15803d; // Verde escuro para contraste
}

// Ícone Flag - Mantém formato atual (amarelo)
.circle.flag-avatar {
  background-color: #9D9029;
  border-color: #8a7a23;
}
.circle.flag-avatar .img_avatar {
  width: 20px;
  height: 20px;
  color: #B9BF3B;
}

// Ícone User - Azul
.circle.user-avatar {
  background-color: #3b82f6; // Azul claro
  border-color: #2563eb;
}
.circle.user-avatar .img_avatar {
  width: 20px;
  height: 20px;
  color: #1d4ed8; // Azul escuro para contraste
}

// Mantém para compatibilidade (caso usado em outro lugar)
.circle.consultant-avatar{
  background-color: #9D9029;
}
.circle.consultant-avatar .img_avatar {
  width: 20px;
  height: 20px;
  color: #B9BF3B;
}

.img_avatar {
  width: 20px;
  height: 20px;
}
.block-divider {
  width: 100%;
  height: 1px;
  background-color: #dcdcdc;
}
.dark-layout .block-divider {
  background-color: #1b2132;
}
.total-value {
  width: 100%;
  text-align: right;
}
</style>
